 /* Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from './layouts/layout.component';

import {CguComponent} from './pages/cgu/cgu.component';
import {CgvComponent} from './pages/cgv/cgv.component';
import {Error404Component} from './pages/error-404/error-404.component';
import {Error403Component} from './pages/error-403/error-403.component';
import {Error500Component} from './pages/error-500/error-500.component';
import {PrivacyComponent} from './pages/privacy/privacy.component';
import {ForgotPasswordComponent} from './pages/forgot-password/forgot-password.component';
import {HelpComponent} from './pages/help/help.component';
import {HistoryComponent} from './pages/history/history.component';
import {HomeComponent} from './pages/home/home.component';
import {LoginComponent} from './pages/login/login.component';
import {MaintenanceComponent} from './pages/maintenance/maintenance.component';
import {ProfileComponent} from './pages/profile/profile.component';
import {RemovalComponent} from './pages/removal/removal.component';
import {AuthGuard} from './_guards/auth.guard';
import {RemovalPointsComponent} from './pages/removal-points/removal-points.component';
import {ResetPasswordComponent} from './pages/reset-password/reset-password.component';
import {BoviclicComponent} from './pages/boviclic/boviclic.component';
import {BoviclicErrorComponent} from './pages/boviclic-error/boviclic-error.component';
import {PayPalValidatedComponent} from './pages/pay-pal-validated/pay-pal-validated.component';
import {PayPalCanceledComponent} from './pages/pay-pal-canceled/pay-pal-canceled.component';
import {CertComponent} from './pages/cert/cert.component';
 import {AtemaxComponent} from "./pages/atemax/atemax.component";

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    children: [
      {
        canActivate: [AuthGuard],
        component: HomeComponent,
        path: 'home'
      },
      {
        canActivate: [AuthGuard],
        component: HistoryComponent,
        path: 'history'
      },
      {
        canActivate: [AuthGuard],
        component: PayPalCanceledComponent,
        path: 'paypal-canceled'
      },
      {
        canActivate: [AuthGuard],
        component: PayPalCanceledComponent,
        path: 'paypal-canceled/:id'
      },
      {
        canActivate: [AuthGuard],
        component: PayPalValidatedComponent,
        path: 'paypal-validated'
      },
      {
        canActivate: [AuthGuard],
        component: PayPalValidatedComponent,
        path: 'paypal-validated/:id'
      },
      {
        canActivate: [AuthGuard],
        component: ProfileComponent,
        path: 'profile'
      },

      {
        canActivate: [AuthGuard],
        component: RemovalComponent,
        path: 'removal'
      },
      {
        canActivate: [AuthGuard],
        component: RemovalComponent,
        path: 'removal/:id'
      },
      {
        canActivate: [AuthGuard],
        component: RemovalPointsComponent,
        path: 'removal-points'
      },
      {
        canActivate: [AuthGuard],
        component: RemovalPointsComponent,
        path: 'removal-points/:id'
      }
    ],
    component: LayoutComponent,
    path: ''
  },
  {
    component: BoviclicComponent,
    path: 'boviclic',
  },
  {
    component: BoviclicComponent,
    path: 'external-removal',
  },
  {
    component: BoviclicErrorComponent,
    path: 'boviclic-error'
  },
  {
    component: CguComponent,
    path: 'cgu'
  },
  {
    component: CgvComponent,
    path: 'cgv'
  },
  {
    component: Error403Component,
    path: 'error-403'
  },
  {
    component: Error404Component,
    path: 'error-404'
  },
  {
    component: Error500Component,
    path: 'error-500'
  },
  {
    component: ForgotPasswordComponent,
    path: 'forgot-password'
  },
  {
    component: AtemaxComponent,
    path: 'atemax'
  },
  {
    component: HelpComponent,
    path: 'help'
  },
  {
    component: LoginComponent,
    path: 'login'
  },
  {
    component: MaintenanceComponent,
    path: 'maintenance'
  },
  {
    component: PrivacyComponent,
    path: 'privacy'
  },
  {
    component: ResetPasswordComponent,
    path: 'reset-password'
  },
  {
    component: CertComponent,
    path: '.well-known/pki-validation/B01736CD31D56E3E832C06224CC0EADA.txt'
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'error-404'
  }
];

@NgModule({
  exports: [
    RouterModule
  ],
  imports: [
    RouterModule.forRoot(APP_ROUTES, {  })
  ]
})

export class RoutingModule {
}
